module.exports = __webpack_public_path__ + "static/media/Desert_Main.ce8a8290.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Desert_Main.webp
// module id = ./src/assets/Desert_Main.webp
// module chunks = 0